import React from 'react';
import { InputItem } from '@beisen/chaos-ui';
import transLoader from '@beisen/i18n-translation-loader';
const defaultTranslation = {
    inputHolder: '点击填写',
    required: '必填',
    searchInputHolder: '点击输入',
    confirm: '确定',
    clear: '清空'
};
class Email extends React.Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.handleClearValue = this.handleClearValue.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);

        this.state = {
            inputValue: props.text
        };
        this.translation = Object.assign({}, defaultTranslation, transLoader({
            inputHolder: 'fieldPlaceHolder.inputHolder',
            required: 'common.required',
            searchInputHolder: 'fieldPlaceHolder.searchInputHolder',
            confirm: 'common.confirm',
            clear: 'common.clear'
        }), props.translation);
    }

    handleClearValue() {
        this.props.handleClosePopUp && this.props.handleClosePopUp();
        this.setState({ inputValue: '' });
        if(this.props.onBlur) {
            this.props.onBlur({ text: '',value: '' });
        }
        this.props.synBizData && this.props.synBizData();
    }

    isReadOnly() {
        return this.props.cmp_data.cmp_status == 'readonly' || this.props.cmp_data.cmp_status == 'default';
    }

    handleChange(e) {
        this.setState({ inputValue: e.target.value });
    }

    handleBlur(e) {
        let text = this.state.inputValue.trim();
        let value = text;
        this.setState({ inputValue: value,showClear: false });
        if(this.props.onBlur) {
            this.props.onBlur({ text, value });
        }
    }

    handleSubmit() {
        this.props.handleClosePopUp && this.props.handleClosePopUp();
        this.props.synBizData && this.props.synBizData();
    }

    shouldComponentUpdate(nextprops, nextState) {
        if(nextprops.value != this.props.value ||
            nextprops.text != this.props.text ||
            JSON.stringify(nextState) != JSON.stringify(this.state) ||
            JSON.stringify(nextprops.errorMessage) != JSON.stringify(this.props.errorMessage) ||
            !Object.is(Immutable.fromJS(this.props.cmpData),Immutable.fromJS(nextprops.cmpData))
          ) {
            return true;
        }
        return false;
    }

    componentWillReceiveProps(nextProps) {
        //if(nextProps.hasOwnProperty('text') && (nextProps.text != this.props.text || nextProps.value != this.props.value)) {
            this.setState({ inputValue: nextProps.text });
        //}
    }

    render() {
       const { desc, errorMessage, ...other } = this.props;
       const errMsg = errorMessage && errorMessage.message;
       return (
                <InputItem
                    {...other}
                    label={this.props.label}
                    value={this.state.inputValue}
                    type="email"
                    stateClass={this.props.stateClass}
                    isReadOnly={this.props.isReadOnly}
                    onChange={this.handleChange}
                    desc={desc}
                    placeholder={this.props.formType === 'searchForm' ?  this.props.cmp_data.promptmessage : undefined}
                    onBlur={this.handleBlur}
                    errorMsg={errMsg}
                    popType={this.props.pop_type}
                    onSubmit={this.handleSubmit}
                    onClearValue={this.handleClearValue}
                    translation={this.translation}
                />
                );
    }
}

Email.defaultProps = {
    cmp_data: {}
};
export default Email;



// WEBPACK FOOTER //
// ./src/components/Field_Components/Email/Email.js